const breadcrumb = {
  state: {
    breadcrumbArray: [],
    parentId: ''
  },
  mutations: {
    setBreadcrumb: (state, val) => {
      state.breadcrumbArray = val
    },
    setParentId: (state, val) => {
      state.parentId = val
    }
  }
};

export default breadcrumb;